<div class="d-md-flex p-3" *ngIf="!isLoading">
    <div class="login-form-wrapper">
        <div class="card mb-3">
            <div class="card-header d-flex align-items-center">
                <!-- <i
                    class="bi bi-person-fill text-white p-1" 
                    style="background: #0f2336;"
                >
                </i> -->
                <h5 class="card-ttl">
                    Update Details
                </h5>
            </div>
            <div class="card-body login-form">
                <form 
                class="form-holder row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 mt-2"
                [formGroup]="registerForm"
                (ngSubmit)="onUpdateSubmit()"
                >
                <div class="col">
                    <label for="firstName" class="form-label">First Name</label>
                    <div class="input-group">
                        <span class="input-group-icon">
                            <i class="bi bi-person"></i>
                        </span>
                        <input 
                            type="text" 
                            class="input form-control" 
                            placeholder="First Name" 
                            autocomplete="off"
                            formControlName="firstName"  
                        />
                    </div>
                </div>
                <div class="col">
                    <label for="lastName" class="form-label">Last Name</label>
                    <div class="input-group">
                        <span class="input-group-icon">
                            <i class="bi bi-person"></i>
                        </span>
                        <input 
                            type="text" 
                            class="input form-control" 
                            placeholder="Last Name" 
                            autocomplete="off"
                            formControlName="lastName"  
                        />
                    </div>
                </div>
                <div class="col">
                    <label for="userName" class="form-label">User Name</label>
                    <div class="input-group">
                        <span class="input-group-icon">
                            <i class="bi bi-person-check"></i>
                        </span>
                        <input 
                            type="text" 
                            class="input form-control" 
                            placeholder="Username" 
                            autocomplete="off"
                            formControlName="userName"  
                        />
                    </div>
                </div>
                <div class="col">
                    <label for="email" class="form-label">Email</label>
                    <div class="input-group">
                        <span class="input-group-icon">
                            <i class="bi bi-envelope"></i>
                        </span>
                        <input 
                            type="email" 
                            class="input form-control" 
                            autocomplete="off" 
                            placeholder="Email" 
                            formControlName="email"
                        />
                    </div>
                </div>
                <div class="col-12 col-lg-12 text-end">
                    <button type="submit" class="btn btn-primary ">
                        Update
                    </button>
                </div>
                </form>
            </div>
        </div>
        <div class="card" >
            <div class="card-header">
                <h5 class="card-title">Change Password</h5>
            </div>
            <div class="card-body  login-form">
                <form 
                    class="form-holder" 
                    [formGroup]="changePasswordForm"
                    (ngSubmit)="onPasswordChangeSubmit()"    
                >
                    <div class="col">
                        <label for="firstName" class="form-label">Current Password</label>
                        <div class="input-group">
                            <span class="input-group-icon">
                                <i class="bi bi-lock"></i>
                            </span>
                            <input 
                                type="password" 
                                class="input form-control" 
                                placeholder="Current Password" 
                                autocomplete="off" 
                                formControlName="currentPassword"
                            />
                        </div>
                    </div>
                    <div class="col">
                        <label for="firstName" class="form-label">New Password</label>
                        <div class="input-group">
                            <span class="input-group-icon">
                                <i class="bi bi-lock"></i>
                            </span>
                            <input 
                                type="password" 
                                class="input form-control" 
                                placeholder="New Password" 
                                autocomplete="off" 
                                formControlName="newPassword"
                            />
                        </div>
                    </div>
                    <div class="col">
                        <label for="firstName" class="form-label">Confirm New Password</label>
                        <div class="input-group">
                            <span class="input-group-icon">
                                <i class="bi bi-lock"></i>
                            </span>
                            <input 
                                type="password" 
                                class="input form-control" 
                                placeholder="Confirm New Password" 
                                autocomplete="off" 
                                formControlName="confirmPassword"
                            />
                        </div>
                    </div>
                    <div class="col-12 text-end" >
                        <button type="submit" class="btn btn-primary flex-end ">Change Password</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-sm-12 h-100 col-md-7 mt-sm-3 mt-md-0 mt-3">
        <section>
            <div class="col">
                <div class="row d-flex justify-content-center align-items-center h-100">
                    <div class="col-lg-10 col-md-10">
                        <div class="card" *ngIf="User">
                            <div class="card-body text-center">
                                <div class="mt-3 mb-4">
                                    <img src="	https://github.com/mdo.png" class="rounded-circle img-fluid"
                                        style="width: 100px;" />
                                </div>
                                <h4 class="mb-2">{{User.firstName +" "+ User.lastName}}</h4>
                                <p class="text-muted mb-4">{{User.userName}} <span class="mx-2">|</span> <a
                                        href="#!">{{User.email}}</a></p>
                                <div class="mb-4 pb-2">
                                    <button type="button"
                                        class="btn btn-outline-primary">
                                        <i class="fab fa-facebook-f fa-lg"></i>
                                    </button>
                                    <button type="button"
                                        class="btn btn-outline-primary">
                                        <i class="fab fa-twitter fa-lg"></i>
                                    </button>
                                    <button type="button"
                                        class="btn btn-outline-primary">
                                        <i class="fab fa-skype fa-lg"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
        
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
<div *ngIf="isLoading">
  <app-loader></app-loader>
</div>